import "./Languages.css"

import {useClientLocale} from "../../context/client_locale";
import {useAdaptiveMobileSize} from "../../hooks/useAdaptiveMobileSize";
import {useLocation, useNavigate} from "react-router-dom";

import AudioItem from "../../components/audioItem/AudioItem";
import {ErrorMessage} from "../../components/errorMessage/ErrorMessage";

import {remoteFilePath} from "../../services/api/File";
import {getStyleForClientRootContainer} from "../../helper/client_block_style";
import adaptiveSize, {getActualResolutionCategory, getWindowSize} from "../../utils/size";

let languageBackgrounds = [
    "#F38D2B",
    "#FFD92F",
    "#019441",
    "#E74538",
]

let languageBorderColor = [
    "#60A162",
    "#FAC73D",
    "#30A088",
    "#138B46",
]

export default function Languages() {
    const adaptiveMobileSize = useAdaptiveMobileSize();
    const navigate = useNavigate();
    const state = useLocation().state;
    const { strings } = useClientLocale();
    const isMobileVersion = state.isMobileVersion;
    const resolutionUnit = getActualResolutionCategory(
        isMobileVersion ? adaptiveMobileSize : getWindowSize()
    );
    const spaceBetweenItem = adaptiveSize(resolutionUnit, 1)
    const verticalPadding = adaptiveSize(resolutionUnit, 4)
    let exhibition = null
    if (state) {
        exhibition = state.exhibition
    }
    let backgroundURL = null

    let mainContent
    if (!exhibition) {
        mainContent = (
            <div className={"h-full w-full flex flex-col justify-center"}>
                <ErrorMessage>{strings["wrong_parameters"]}</ErrorMessage>
            </div>
        )
    } else {
        const languageID = exhibition.backgroundImages["Language"];
        backgroundURL = remoteFilePath(languageID)
        function onItemClick(id) {
            navigate("/play", {
                state: {
                    ...state,
                    mediaID: id,
                }
            })
        }
        let medias = [...exhibition.videos, ...exhibition.audios, ...exhibition.images];
        medias.sort((lhs, rhs) => {
          const lhsScore = exhibition.mediaOrder[lhs.id] ?? 0
          const rhsScore = exhibition.mediaOrder[rhs.id] ?? 0
          return rhsScore - lhsScore
        });
        const height = 0.06 * window.innerHeight;
        mainContent = medias.map((media, idx) => {
          const backgroundIdx = idx % languageBackgrounds.length;
          const borderIdx = idx % languageBorderColor.length;
          return (
              <AudioItem
                  resolutionUnit={resolutionUnit}
                  id={media.id}
                  key={media.id}
                  height={height}
                  backgroundColor={languageBackgrounds[backgroundIdx]}
                  borderColor={languageBorderColor[borderIdx]}
                  title={media.title}
                  onItemClick={onItemClick}
              >
                {media.title.toUpperCase()}
              </AudioItem>
          )
        })
    }
    const containerStyle = getStyleForClientRootContainer(backgroundURL, adaptiveMobileSize, isMobileVersion);
    return (
        <div className="flex flex-row justify-center">
          <div className="bg-center bg-no-repeat" style={containerStyle}>
            <div
                className="h-full flex flex-row items-center py-16 mt-4"
                style={{
                    paddingLeft: `${verticalPadding}px`,
                    paddingRight: `${verticalPadding}px`,
                }}
            >
                <ul
                    className="w-full default-ul flex flex-col"
                    style={{
                        gap: `${spaceBetweenItem}px`
                    }}
                >
                    {mainContent}
                </ul>
            </div>
          </div>
        </div>
    )
}
